import styled from 'styled-components';
const StyledOperationsHubOnboardingOverviewMenuButtons = styled.div.withConfig({
  displayName: "StyledOperationsHubOnboardingOverviewMenuButtons",
  componentId: "sc-1vn04q1-0"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;gap:10px;"]);
export default StyledOperationsHubOnboardingOverviewMenuButtons;